import '../jquery'

let ready_legacy_admin_dns;

ready_legacy_admin_dns = function() {
  var $checked, setChecked, setPartialyChecked, setUnchecked;
  $checked = false;
  $('#admin_dns_check_all').on('click', function(event) {
    var cbxs;
    cbxs = $('#admin_dns').find('input[type="checkbox"]');
    cbxs.prop('checked', $checked = !$checked);
    if ($checked) {
      setChecked();
    } else {
      setUnchecked();
    }
  });
  setChecked = function() {
    $('#admin_dns_check_all').find('i').removeClass('fa-square').removeClass('fa-minus-square').addClass('fa-check-square');
    $checked = true;
  };
  setUnchecked = function() {
    $('#admin_dns_check_all').find('i').removeClass('fa-check-square').removeClass('fa-minus-square').addClass('fa-square');
    $checked = false;
  };
  setPartialyChecked = function() {
    $('#admin_dns_check_all').find('i').removeClass('fa-check-square').removeClass('fa-square').addClass('fa-minus-square');
    $checked = false;
  };
  $('.admin_dns_select_all').on('click', function(event) {
    var cbxs;
    event.preventDefault();
    cbxs = $('#admin_dns').find('input[type="checkbox"]');
    cbxs.prop('checked', true);
    setChecked();
  });
  $('.admin_dns_select_none').on('click', function(event) {
    var cbxs;
    event.preventDefault();
    cbxs = $('#admin_dns').find('input[type="checkbox"]');
    cbxs.prop('checked', false);
    setUnchecked();
  });
  return $('.admin_batch_action').on('click', function(event) {
    event.preventDefault();
    return $.ajax({
      type: 'POST',
      url: $(this).data('url'),
      beforeSend: function(xhr) {
        return xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      data: {
        ids: $('input.admin_batch_check[type="checkbox"]:checked').map(function() {
          return $(this).data('id');
        }).get()
      }
    });
  });
};

$(document).ready(ready_legacy_admin_dns);

$(document).on('turbo:load', ready_legacy_admin_dns);